<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>部门模块</el-breadcrumb-item>
        <el-breadcrumb-item>部门详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">部门名称：</div>
          <el-input v-model="user.name"
                    :disabled="inputDisabled"
                    style="width: unset;"
                    placeholder="请输入部门名称"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">负责人姓名：</div>
          <el-input v-model="user.contacts"
                    :disabled="inputDisabled"
                    style="width: unset;"
                    placeholder="请输入员工名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">负责人电话：</span>
          <el-input v-model="user.tel"
                    :disabled="inputDisabled"
                    class="inputRight"
                    maxlength="11"
                    style="width: unset;"
                    placeholder="请输入负责人电话"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">备注：</span>
          <el-input v-model="user.remark"
                    :disabled="inputDisabled"
                    type="textarea"
                    class="inputRight"
                    style="width: 200px;"
                    placeholder="请输入备注"></el-input>
        </div>
        <div class="inputDiv">
          <el-button type="primary"
                     @click="onEdit"
                     class="widthButton">{{
            edit
          }}</el-button>
          <el-button class="widthButton"
                     @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { deptUpdate } from "@/api/department";
export default {
  data() {
    return {
      user: {
        id: "",
        name: "",
        contacts: "",
        tel: "",
        remark: ""
      },
      inputDisabled: true,
      edit: "编辑"
    };
  },
  mounted() {
    this.user = this.$route.query;
  },
  methods: {
    onEdit() {
      if (this.inputDisabled) {
        this.inputDisabled = false;
        this.edit = "确定";
      } else {
        const params = {
          id: this.user.id,
          tel: this.user.tel,
          name: this.user.name,
          contacts: this.user.contacts,
          remark: this.user.remark
        };
        deptUpdate(params)
          .then(res => {
            if (res.count == 1) {
              this.inputDisabled = true;
              this.edit = "编辑";
              this.$message({
                type: "success",
                message: "修改成功!"
              });
              this.back();
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
